import {
    store
} from '@/store/store'
import axios from 'axios'

// export const axiosJwt = axios.create({
//     headers: {
//         'Authorization': `Bearer ${store.getters.getToken}`,
//         'Content-Type': 'application/json'
//     }
// });

export const axiosJwt = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});


axiosJwt.interceptors.request.use(
    config => {
        const token = store.getters.getToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);
